/** Circle size grows with digit count so large totals stay inside the badge. */
export const getMessageCountCircleSize = (count) => {
  const digits = String(Math.abs(Number(count) || 0)).length;
  const size =
    digits <= 2 ? 36 : digits === 3 ? 44 : digits === 4 ? 54 : digits === 5 ? 64 : 74;
  const fontSize =
    digits >= 6 ? 11 : digits >= 5 ? 12 : digits === 4 ? 13 : 14;

  return {
    width: `${size}px`,
    height: `${size}px`,
    minWidth: `${size}px`,
    minHeight: `${size}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: `${fontSize}px`,
    lineHeight: 1,
    flexShrink: 0,
    borderRadius: "50%",
    boxSizing: "border-box",
  };
};
